import "./CompanyInputComponent.scss";
import {IOnInit, IPostLink, IRootElementService} from "angular";
import {CompanyService} from "../../../services/company/CompanyService";
import {CompanyInfo} from "../../../types/Company";
import {Optional} from "../../../js/util/Optional";
import {ComponentCallback} from "../../../types/AngularJS";

export const CompanyInput = "tfCompanyInput";

export function tfCompanyInput() {
    return {
        template,
        bindings: {
            company: "<",
            displayName: "<",
            hasOptions: "<",
            hasCollateral: "<",
            excludeIndexes: "<",
            appendToBody: "<",
            placeholder: "@",
            required: "<",
            resetOnSelect: "<",
            selectOnMatch: "<",
            autofocus: "<",
            inputDisabled: "<",
            onChange: "&",
            onBlur: "&"
        },
        controller: CompanyInputComponentController,
        controllerAs: "ctrl"
    };
}

export class CompanyInputComponentController implements IOnInit, IPostLink {

    public company: string | null;
    public companyName?: string | null;
    public placeholder?: string;
    public selectOnMatch?: boolean;
    public readonly hasOptions: boolean;
    public readonly displayName?: boolean;
    public readonly hasCollateral: boolean;
    public readonly excludeIndexes?: boolean;
    public readonly appendToBody?: boolean;
    public readonly required?: boolean;
    public readonly resetOnSelect?: boolean;
    public readonly autofocus?: boolean;
    public inputDisabled = false;
    public readonly onChange: ComponentCallback;
    public readonly onBlur: ComponentCallback;

    private companies: Promise<Array<CompanyInfo>>;

    /** @ngInject */
    public constructor(private readonly $element: IRootElementService,
                       private readonly companyService: CompanyService) {

    }

    public $onInit(): void {
        this.placeholder = this.placeholder || "Select Symbol";
        this.selectOnMatch = Optional.of(this.selectOnMatch).orElse(true);
    }

    public $postLink(): void {
        if (this.autofocus) {
            this.$element.find("input").focus();
        }
    }

    public async findCompanies(input: string) {
        const companies = await this.loadCompanies();
        const filtered = companies.filter(c => this.excludeIndexes !== true || c.code !== "XJO");
        return this.companyService.findCompanies(filtered, input);
    }

    private async loadCompanies(): Promise<Array<CompanyInfo>> {
        if (this.companies == null) {
            const companies = await this.companyService.companies(this.hasOptions, this.hasCollateral);

            this.companies = Promise.resolve(companies);
        }
        return this.companies;
    }

    public async onCompanyChanged() {
        const companies = await this.loadCompanies();
        const company = companies.find(c => c.code === this.company);
        this.companyName = company?.name;
        this.onChange({company});
        if (this.resetOnSelect === true) {
            this.company = null;
        }
    }
}

const template = `
    <script type="text/ng-template" id="companySearchResult.html">
        <a>
            <div><strong>{{match.model.code}}</strong><span>.{{match.model.exchange}}</span></div>
            <div>{{match.model.name}}</div>
        </a>
    </script>

    <input type="text"
        class="form-control"
        typeahead-template-url="companySearchResult.html"
        typeahead-focus-first="true"
        typeahead-editable="false"
        typeahead-select-on-blur="true"
        typeahead-select-on-exact="ctrl.selectOnMatch"
        typeahead-on-select="ctrl.onCompanyChanged()"
        typeahead-append-to-body="ctrl.appendToBody"
        uib-typeahead="company.code for company in ctrl.findCompanies($viewValue)"
        placeholder="{{ctrl.placeholder}}"
        ng-model="ctrl.company"
        ng-required="ctrl.required"
        ng-blur="ctrl.onBlur()"
        ng-if="!ctrl.inputDisabled">

    <input type="text"
        class="form-control"
        typeahead-template-url="companySearchResult.html"
        typeahead-focus-first="true"
        typeahead-editable="false"
        typeahead-select-on-blur="true"
        typeahead-select-on-exact="ctrl.selectOnMatch"
        typeahead-on-select="ctrl.onCompanyChanged()"
        typeahead-append-to-body="ctrl.appendToBody"
        uib-typeahead="company.code for company in ctrl.findCompanies($viewValue)"
        placeholder="{{ctrl.placeholder}}"
        ng-model="ctrl.company"
        ng-required="ctrl.required"
        ng-blur="ctrl.onBlur()"
        ng-if="ctrl.inputDisabled"
        disabled>
    <div class="mt-10" ng-show="ctrl.companyName && ctrl.displayName">
      {{ctrl.companyName}}
    </div>
`;
